import React from "react";

import styled from "styled-components";
import ReactJson from 'react-json-view';

export default function Transaction({ json }) {
    return (
        <Container>
            <ReactJson src={json} />
        </Container>
    )
}

const Container = styled.div`
    height: 100%;
    width: 100%;
    padding: 40px;
`;